import React from 'react';
import Icon from '@/components/atoms/UI/Icon/Icon';
import styled, { css } from 'styled-components';
import { basicColor } from '@/styles/template';

interface AnswerImgProps {
	src: string;
	correct: boolean;
}


const Wrap = styled.div`
  position: relative;
  text-align: center;
  padding: 2rem 0;
  margin: 2rem 0;
`;


const AnswerIcon = styled.div<{correct?: boolean}>`
	background: ${basicColor.red};
	border-radius: 50%;
	width: 4rem;
	height: 4rem;
	position: absolute;
	left: 0;
	right: 0;
	margin: auto;
	top: -20px;
	display: flex;
	align-content: center;
	align-items: center;
	justify-content: center;

  
  	&::before {
      content: '';
      display: block;
      position: absolute;
      width: 8px;
      height: 8px;
      left: 0;
      bottom: -2px;
      right: 0;
      margin: auto;
      transform: rotate(-60deg) skewX(-30deg) scale(1, 0.866);
      border-bottom-left-radius: 2px;
      background: ${basicColor.red};
	  
    }

	${({ correct }) => correct && css`
	    background: ${basicColor.secondary};

		&::before {
			background: ${basicColor.secondary};
		}
	`}
`;

const AnswerCorners = styled.div<{correct?: boolean}>`
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  
	& span {
		display: block;
		position: absolute;
		width: 1rem;
		height: 1rem;
	  	border-style: solid;
		border-color: ${basicColor.red};
	  	
		border-width: 0 3px 3px 0;
		border-bottom-right-radius: 3px;
	}

	
	
	& span:nth-child(1) {
		top: 0;
		left: 0;
		transform: rotate(180deg);
	}
	
	& span:nth-child(2) {
		top: 0;
		right: 0;
		transform: rotate(270deg);
	}
	
	& span:nth-child(3) {
		bottom: 0;
		left: 0;
		transform: rotate(90deg);
		}
	
	& span:nth-child(4) {
		bottom: 0;
		right: 0;
	}


  ${({ correct }) => correct && css`
		& span {
		  border-color: ${basicColor.secondary};
		}
	`}
`;

const WrongIcon = styled(Icon)`
	& .themedIcon {
	  fill: ${basicColor.white};
	}
`;

const ResultAnswerImg: React.FC<AnswerImgProps> = ({ src, correct }) => {
	return (
		<Wrap>
			<AnswerIcon correct={correct}>
				{correct ? <Icon name='Check' xSmall/> : <WrongIcon name='Close' />}
			</AnswerIcon>
			<AnswerCorners correct={correct}>
				<span></span><span></span><span></span><span></span>
			</AnswerCorners>
			<img alt='' src={src} />
		</Wrap>
	)
}

export default ResultAnswerImg